// FIXME: Implementation of this function might not be very optimized due to serializaton/deserialization
export default function replacePropertyValueDeep(object, keyTransformationFns = {}) {
  return JSON.parse(JSON.stringify(object), (key, value) => {
    const transformationFn = keyTransformationFns[key]
    return transformationFn ? transformationFn(value) : value
  })
}
